import { Component, OnInit, Input, ViewChild, SimpleChange, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core'
import { FacilityService } from '../services/facility.service';
import { FacilityDetail } from '../types/FacilityDetail';
import { BusinessCategory } from '../types/BusinessCategory';
import { Facility } from '../types/Facility'
import { ProspectListItem } from '../types/ProspectListItem';
import { EstimatesAndActuals } from "../types/EstimatesAndActuals";
import { Status } from "../types/Status";
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { Lookup } from 'src/app/common/model/lookup';
import { LookupService } from 'src/app/common/service/lookup.service';
import { ungzip, gzip, deflate, inflate, deflateRaw, inflateRaw } from "pako";
import { IndustrialGasUOM } from '../types/IndustrialGasUOM';
import { Router } from '@angular/router';
import { BusinessPotentialComponent } from './business-potential.component';
import { BusinessModel } from '../types/BusinessModel';
import { NotificationTypes } from 'src/app/common/component/notification/notification.component';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { Constants } from 'src/app/common/constants';
import { ProductUOMConversionsService } from 'src/app/common/service/productuomconversions.service';
import { IndustrialGases } from "../types/IndustrialGases";

@Component({
  selector: 'facility-details',
  templateUrl: './facility-details.component.html',
  styleUrls: ['./facility-details.component.scss']
})
export class FacilityDetailsComponent implements OnInit, OnChanges {
  @ViewChild('BusinessPotentialComponent') businessPotentialComponent: BusinessPotentialComponent;
  @ViewChild("sourceLinkGrid") dataGrid: DxDataGridComponent;
  @ViewChild("facilityDescriptionCombined") selectBox: DxSelectBoxComponent;
  @ViewChild("constructionStartupYear") constructionSelectBox: DxSelectBoxComponent;
  @Output() loadPanelVisibleEvent = new EventEmitter<boolean>();
  @Input() isNewFacility: Boolean;
  @Input() facility: Facility;
  @Input() industrialGasUOMs: IndustrialGasUOM[];
  @Input()
  get facilityType(): string { return this._facilityType; }
  set facilityType(facilityType: string) {
    if (facilityType === 'General') {
      this.capitalLabel = "Capital Investment: ";
      this.isGeneralFacilityType = true;
      this.isHYCOFacilityType = false;
    }
    else if (facilityType === 'HYCO') {
      this.isHYCOFacilityType = true;
      this.isGeneralFacilityType = false;
    } else {
      this.capitalLabel = "Total Capital: ";
      this.isGeneralFacilityType = false;
      this.isHYCOFacilityType = false;
    }
  }
  _facilityType: string;
  facilityDetails: FacilityDetail[];
  facilityDetailsCombined: FacilityDetail[];
  drivers: ProspectListItem[];
  currencies: Lookup[] = [];
  capacityUOMs: Lookup[];
  supplyModes: ProspectListItem[];
  estProbabilities: Lookup[] = [];
  fileTypes: Lookup[] = [];
  fileType: number;
  constructionStartupYears: number[] = [];
  repEstAwardYears: number[] = [];
  actEstAwardYears: number[] = [];
  statuses: Status[];
  capitalLabel: string;
  isGeneralFacilityType: boolean = true;
  isAnyEquipmentAttached: boolean = false;
  isAnyEquipmentSelected: boolean = false;
  isHYCOFacilityType: boolean = false;
  currencyConversionPopupVisible: boolean = false;
  searchModeOption = 'contains';
  dataSource: any;
  oldData: any;
  selectedRowIndex = -1;
  businessModels: BusinessModel[];
  businessCategories: BusinessCategory[];
  now: Date = new Date();
  selectedItemKeys: any[] = [];
  equipmentSelectedItemKeys: any[] = [];
  feedstockVisible: boolean = false;
  products = [];

  constructor(private facilityService: FacilityService, private lookupService: LookupService, private router: Router, private notificationService: NotificationService,
    private productUOMConversionsService: ProductUOMConversionsService) {
    this.validateCapacity = this.validateCapacity.bind(this);
    this.onEditorPreparing = this.onEditorPreparing.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.getIndustrialGasUOMs = this.getIndustrialGasUOMs.bind(this);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.businessPotentialComponent !== undefined && this.businessPotentialComponent !== null) {
      this.businessModels = this.businessPotentialComponent.businessModels;
    }

    if (this.facility.facilityDetail.productionActivityId !== null && this.facility.facilityDetail.productionActivityId !== undefined) {
      this.getProductionActivityById();
    }

    if (this.facility.equipments.length > 0) {
      this.isAnyEquipmentAttached = true;
    }
  }

  ngOnInit(): void {

    this.lookupService.getLookupValues('Currency')
      .subscribe(
        (data: Lookup[]) => {
          this.currencies = data
        }
      );

    this.lookupService.getLookupValues('CapacityUOM')
      .subscribe(
        (data: Lookup[]) => {
          this.capacityUOMs = data
        }
      );

    this.lookupService.getLookupValues('RepEstProbability')
      .subscribe(
        (data: Lookup[]) => {
          this.estProbabilities = data
        }
      );

    this.lookupService.getLookupValues('FileType')
      .subscribe(
        (data: Lookup[]) => {
          this.fileTypes = data
        }
      );

    this.facilityService.GetSupplyModes()
      .subscribe(
        (data: ProspectListItem[]) => {
          this.supplyModes = data
        }
      );

    this.facilityService.GetBusinessModels()
      .subscribe(
        (data: BusinessModel[]) => {
          this.businessModels = data
        }
      );

    if (this.isNewFacility) {
      this.facilityService.getAllProductionActivity()
        .subscribe(
          (data: FacilityDetail[]) => {
            this.facilityDetails = data
          }
        );
    }

    this.facilityService.GetAllProspectDriver()
      .subscribe(
        (data: ProspectListItem[]) => {
          this.drivers = data
        }
      );

    this.facilityService.getAllStatus()
      .subscribe(
        (data: Status[]) => {
          this.statuses = data
        }
      );

    if (this.isNewFacility === false) {
      this.facilityService.getBusinessCategories()
        .subscribe(
          (data: BusinessCategory[]) => {
            this.businessCategories = data
          }
        );
    }

    var date = new Date();
    var year = date.getFullYear() - 15;

    for (var index = year; index < year + 35; index++) {
      this.constructionStartupYears.push(index);
      this.repEstAwardYears.push(index);
      this.actEstAwardYears.push(index);

    }

    this.facilityService.getIndustrailGases()
      .subscribe((data: IndustrialGases[]) => {
        this.products = data;
      });
  }

  onDescriptionValueChanged() {
    if (this.facility.facilityDetail.productionActivityId !== null && this.facility.facilityDetail.productionActivityId !== undefined) {
      this.getProductionActivityById();
    }
  }

  currencyConversion() {
    this.currencyConversionPopupVisible = true;
  }

  getProductionActivityById() {
    this.facilityService.getProductionActivityById(this.facility.facilityDetail.productionActivityId)
      .subscribe(
        (data: FacilityDetail[]) => {
          this.facilityDetailsCombined = data
        }
      );
  }

  onSaved() {
    this.facility.actualsEdited = true;
    this.facility.estimatesAndActualsTemp = JSON.parse(JSON.stringify(this.facility.estimatesAndActuals));
  }

  closePopupWindow(closeFlag: boolean) {
    this.currencyConversionPopupVisible = false;
  }

  onEditingStart(e) {
    setTimeout(() => {
      var cell = e.component.getCellElement(e.component.getRowIndexByKey(e.key), "Comments");
      e.component.focus(cell);
    }, 10);
  }

  feedstockClose() {
    this.feedstockVisible = false;
  }

  readFiles(e) {
    let that = this;
    let index = 0;
    if (e.value && e.value[0]) {
      function readFile(file) {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          that.facility.facilityDetail.attachments[index].fileName = file.name
          that.facility.facilityDetail.attachments[index].fileType = that.fileType
          console.log(that.fileType)
          const compressed = gzip(reader.result)
          const base64Content = that.bytesToBase64(compressed)
          that.facility.facilityDetail.attachments[index].content = base64Content;
          index++
        }, false);

        reader.readAsArrayBuffer(file);
      }

      if (e.value) {
        [].forEach.call(e.value, readFile);
      }
    }
  }

  download(fileName) {
    this.loadPanelVisibleEvent.emit(true);
    this.facilityService.LoadAttachmentContent(this.facility.productionFacilityId, fileName)
      .subscribe(
        (data: string) => {
          const uint8Data = this.base64ToBytes(data)
          const content = ungzip(uint8Data)
          this.saveFile(fileName, content)
          this.loadPanelVisibleEvent.emit(false);
        }
      );

    return false;
  }

  saveFile(filename, content) {
    // Create the URL
    const file = new File([content], filename, { type: "data:application/octet-stream;base64" });
    const exportUrl = URL.createObjectURL(file);

    // Create the <a> element and click on it
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = exportUrl;
    a.download = filename;
    a.target = "_self";
    a.click();

    // We don't need to keep the object URL, let's release the memory
    // On older versions of Safari, it seems you need to comment this line...
    URL.revokeObjectURL(exportUrl);
  }

  base64ToBytes(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
  }

  bytesToBase64(bytes) {
    var binary = '';
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  onEditorPreparing = (e) => {
    if (e.parentType === "dataRow" && e.dataField === "uom") {
      let that = this;
      e.editorOptions.onValueChanged = function (ev) {
        let selectedItem = ev.component.option("selectedItem");
        // In case of Steam,Syngas or Other Products, Manual conversion of quantity is required
        if ([Constants.industrialGas_Syngas, Constants.industrialGas_Steam, Constants.industrialGas_Other].indexOf(e.row.data.industrialGasId) > -1) {
          e.setValue(selectedItem.uom);
          that.notificationService.alert(NotificationTypes.Warning, "Please calculate the Quantity manually and update the same", null);
        } else {
          that.loadPanelVisibleEvent.emit(true);
          if (ev.previousValue) {
            that.productUOMConversionsService.getProductUOMConversion(e.row.data.industrialGas, 'Gas', ev.previousValue, ev.value).subscribe({
              next: data => {
                e.row.data.industrialGasQuantity = (e.row.data.industrialGasQuantity * eval(data.conversionFactorValue)).toFixed(4);
                e.row.data.uom = selectedItem.uom;
                that.loadPanelVisibleEvent.emit(false);
              }, error: (error) => {
                that.loadPanelVisibleEvent.emit(false);
                that.notificationService.alert(NotificationTypes.Error, "Error while fetching UOM Conversion data", error);
              }
            });
          } else {
            e.row.data.industrialGasQuantity = e.row.data.industrialGasQuantity;
            e.setValue(selectedItem.uom);
            that.loadPanelVisibleEvent.emit(false);
          }
        }
      };
    }
  };

  getIndustrialGasUOMs(options) {
    if (options && options.data && options.data.industrialGasId == Constants.industrialGas_Power) {
      return {
        store: this.industrialGasUOMs,
        filter: options.data ? ["uom", '=', 'MWe'] : null,
      }
    } else {
      return {
        store: this.industrialGasUOMs,
        filter: options.data ? ["uom", '<>', 'MWe'] : null,
      }
    };
  }

  cancelEdit(e) {
    this.facility.estimatesAndActuals = JSON.parse(JSON.stringify(this.facility.estimatesAndActualsTemp));
  }

  onDescriptionCombinedValueChanged(e) {
    if (this.facility.facilityDetail.productionActivityId !== undefined) {
      if (this.isNewFacility) {
        this.facility.facilityDetail.businessCatogoryId = this.selectBox.selectedItem.businessCategoryId;
      }

      var capacity = -1;
      if (this.facility.facilityDetail.activityProcessFeedstockId !== null) {
        this.facilityService.getFacilityEstimatesAndActuals(capacity, this.facility.facilityDetail.activityProcessFeedstockId, this.facility.productionFacilityId)
          .subscribe(
            (data: EstimatesAndActuals[]) => {
              this.facility.estimatesAndActuals = data;
              this.facility.estimatesAndActuals.forEach(e => {
                if (e.estimateSupplyFlag === null) {
                  e.estimateSupplyFlag = false;
                }
                if (e.supplyFlag === null) {
                  e.supplyFlag = false;
                }
                if (e.opportunityAwarded == null) {
                  e.opportunityAwarded = false;
                }
              });
              this.facility.estimatesAndActualsTemp = JSON.parse(JSON.stringify(data));
            }
          );
      }
    }

  }


  onDateBoxContentReady(e) {
    e.component.option('inputAttr', { readonly: true })
  }

  selectionChanged(data: any) {
    this.selectedItemKeys = data.selectedRowKeys;
  }

  equipmentSelectionChanged(data: any) {
    this.equipmentSelectedItemKeys = data.selectedRowKeys;
    if (this.equipmentSelectedItemKeys.length > 0) {
      this.isAnyEquipmentSelected = true;
    }

  }

  validateCapacity(e) {
    if ((this.facility.facilityDetail.capacity !== undefined && this.facility.facilityDetail.capacity !== null) && e.value === undefined) {
      return false;
    }
    else {
      return true;
    }
  }

  onUpdating(e: any) {
    this.oldData = Object.assign({}, e.oldData);
    const index = this.facility.facilityDetail.sourceLinks.indexOf(this.oldData.url);
    if (index !== -1) {
      this.facility.facilityDetail.sourceLinks[index] = e.newData.url;
    }
  }

  viewAllActivityFeedstock() {
    this.feedstockVisible = true;
  }

  setUOMValue(rowData: any, value: any): void {
    (<any>this).defaultSetCellValue(rowData, value);
  }

  editEquipment() {
    this.router.navigate(
      [`/update-equipment/${this.equipmentSelectedItemKeys[0]}/${this.facility.productionFacilityId}`],
      { queryParams: { siteId: this.facility.siteId, facilityCallBack: true } }
    );
  }

  addEquipment() {
    this.router.navigate(
      [`/add-equipment/${this.facility.productionFacilityId}`],
      { queryParams: { siteId: this.facility.siteId, facilityCallBack: true } }
    );
  }

  deleteRecords() {
    this.selectedItemKeys.forEach((item) => {
      const rowIndex = this.dataGrid.instance.getRowIndexByKey(item);
      this.dataGrid.instance.deleteRow(rowIndex);
      this.dataGrid.instance.refresh();
      const index = this.facility.facilityDetail.sourceLinks.indexOf(item.sourceLinks);
      if (index > -1) {
        this.facility.facilityDetail.sourceLinks.splice(index, 1);
      }
    });
  }

}

